import type {
  Contact,
  ContactInput,
  ContactPatch,
  ContactPurpose,
  ContactResolution,
} from '../domain/contact';
import { contactsApi as liveApi } from './live-contacts-api';
import { contactsApi as mockApi } from './mock-contacts-api';

/**
 * Contacts, backed by leatherback's Contacts service (tidaltech/koi#8359) --
 * see domain/contact.ts. Staff only.
 */
export interface ContactsApi {
  listCustomerContacts(customerId: string, includeInactive?: boolean): Promise<Contact[]>;
  /** Everyone who applies to the site: its own, its region's and its customer's. */
  listSiteContacts(siteId: string): Promise<Contact[]>;
  createContact(input: ContactInput): Promise<Contact>;
  /** Rejects with ConflictError when the contact changed since `version`. */
  updateContact(patch: ContactPatch): Promise<Contact>;
  deleteContact(id: string): Promise<void>;
  /** Who to talk to at the site, per purpose (all purposes when omitted). */
  resolveContacts(siteId: string, purpose?: ContactPurpose): Promise<ContactResolution[]>;
}

export const contactsApi: ContactsApi =
  import.meta.env.VITE_API_MODE === 'live' ? liveApi : mockApi;
